import { AreaUnit, PricingPlan } from '../../../graphql/graphql';
import { getReturnUrl } from '../../../helpers/functions/navigation';
import { BaseRootStore } from '../../rootStore/baseRootStore';
import useUser from './useUser';

export default function useStartFreeTrial(rootStore: BaseRootStore) {
  const { userStore } = rootStore;
  const { customer } = useUser(rootStore);

  const startFreeTrial = async (areaUnit: AreaUnit) => {
    const trialActive = await userStore.startFreeTrial({ areaUnit });

    if (trialActive && window.top) {
      window.top.location.href = getReturnUrl(
        PricingPlan.FreeTrial,
        customer?.id,
      );
    }
  };

  return {
    startFreeTrial,
  };
}
